import { Component, Input } from '@angular/core';
import { Summary } from '../types';

@Component({
  selector: 'dashboard-price-agreements-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class DashboardPriceAgreementsSummaryComponent {
  @Input() data: Summary = {
    active: 0,
    expiringSoon: 0,
    blocked: 0
  };
}
